'use client';
import clsx from 'clsx';
import { Markdown } from './Markdown';
import { OpenAPIDisclosureGroup } from './OpenAPIDisclosureGroup';
import { OpenAPIResponse } from './OpenAPIResponse';
import { useResponseExamplesState } from './OpenAPIResponseExampleContent';
import { StaticSection } from './StaticSection';
import { t } from './translate';
import { createStateKey, getStatusCodeClassName, getStatusCodeDefaultLabel } from './utils';
/**
 * Display an interactive response body.
 */
export function OpenAPIResponses(props) {
    var _a;
    var responses = props.responses, context = props.context;
    var groups = Object.entries(responses).map(function (_a) {
        var statusCode = _a[0], response = _a[1];
        var tabs = (function () {
            var _a;
            // If there is no content, but there are headers, we need to show the headers
            if ((!response.content || !Object.keys(response.content).length) &&
                response.headers &&
                Object.keys(response.headers).length) {
                return [
                    {
                        key: 'default',
                        label: '',
                        body: (<OpenAPIResponse response={response} mediaType={{}} context={context}/>),
                    },
                ];
            }
            return Object.entries((_a = response.content) !== null && _a !== void 0 ? _a : {}).map(function (_a) {
                var contentType = _a[0], mediaType = _a[1];
                return ({
                    key: contentType,
                    label: contentType,
                    body: (<OpenAPIResponse response={response} mediaType={mediaType} context={context}/>),
                });
            });
        })();
        var description = response.description;
        return {
            key: statusCode,
            label: (<div className="openapi-response-tab-content">
                        <span className={clsx('openapi-statuscode', "openapi-statuscode-".concat(getStatusCodeClassName(statusCode)))}>
                            {statusCode}
                        </span>
                        {description ? (<Markdown source={description} className="openapi-response-description"/>) : (getStatusCodeDefaultLabel(statusCode, context))}
                    </div>),
            tabs: tabs,
        };
    });
    var state = useResponseExamplesState(context.blockKey, (_a = groups[0]) === null || _a === void 0 ? void 0 : _a.key);
    return (<StaticSection header={t(context.translation, 'responses')} className="openapi-responses">
            <OpenAPIDisclosureGroup icon={context.icons.chevronRight} expandedKeys={state.key ? new Set([state.key]) : new Set()} onExpandedChange={function (keys) {
            var _a;
            var key = (_a = keys.values().next().value) !== null && _a !== void 0 ? _a : null;
            state.setKey(key);
        }} groups={groups} selectIcon={context.icons.chevronDown} selectStateKey={createStateKey('response-media-types', context.blockKey)}/>
        </StaticSection>);
}
